import { init_adsense_lazy_load } from "../utils/ads";

function insertAfter(newNode, referenceNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

export function init_infinite_scroll() {
    // disable module if infinite scroll is not allowed
    if (!window.ENABLE_INFINITE_SCROLL) {
        return;
    }

    // DOM selectors
    var body_flag_class = "iscroll-enabled";
    var body_last_page_class = "iscroll-last-page";
    var prev_page_link_selector = ".iscroll-prev";
    var next_page_link_selector = ".iscroll-next";
    var content_selector = ".iscroll-content:last-of-type";
    var content_end_selector = ".iscroll-content-end";

    // DOM elements
    var content = document.querySelector(content_selector);
    var next_page_link = document.querySelector(next_page_link_selector);

    if (!next_page_link) return null; // if content do not exist, skip infinite scroll

    content.insertAdjacentHTML("afterend", '<div class="spinner mt20 mb20" style="display: none;"></div>');
    var loader_elm = content.nextSibling; // get inserted loader

    // variables
    var observer;
    var next_page_path = next_page_link.getAttribute("href");
    var loading_in_progress = false;

    function init() {
        if (next_page_path != null && window.ENABLE_INFINITE_SCROLL == true) {
            document.body.classList.add(body_flag_class);

            observer = new IntersectionObserver(
                function (entries, observer) {
                    [].forEach.call(entries, function (entry) {
                        if (entry.isIntersecting && loading_in_progress == false) {
                            load_next_page();
                        }
                    });
                },
                {
                    rootMargin: "1200px", // number of px when next page will be loaded
                }
            );

            var content_end_elm = document.querySelector(content_end_selector);
            observer.observe(content_end_elm);
        }

        // insert link to previous pages before content
        var prev_page_link_elm = document.querySelector(prev_page_link_selector);
        if (prev_page_link_elm) {
            content.insertBefore(prev_page_link_elm, content.firstChild);
        }

        window.addEventListener("unload", function () {
            save_scroll_position_to_history();
        });
    }

    function disconnect_observer() {
        document.body.classList.add(body_last_page_class); // last page reached
        observer.disconnect();
    }

    function load_next_page() {
        loader_elm.style.display = "";
        loading_in_progress = true;

        var request = new XMLHttpRequest();
        request.open("GET", next_page_path, true);

        request.onload = function () {
            if (request.status == 200) {
                var parser = new DOMParser();
                var parsed_html = parser.parseFromString(request.responseText, "text/html");

                // push virtual pageview to GA
                window.ga("send", "pageview", next_page_path);
                window.ga("deprecated.send", "pageview", next_page_path);

                // append loaded content to the page
                let last_page_content = parsed_html.querySelector(content_selector);

                // find next_page_link
                next_page_link = parsed_html.querySelector(next_page_link_selector);
                if (next_page_link == null) {
                    disconnect_observer();
                } else {
                    next_page_path = next_page_link.getAttribute("href");
                }

                // remove all flaged nodes
                last_page_content.querySelectorAll(".iscroll-remove").forEach(function (node) {
                    node.parentNode.removeChild(node);
                });

                content = document.querySelector(content_selector);
                insertAfter(last_page_content, content);

                // render preact widgets and lazyloaded images and ads
                document.render_widgets();
                init_adsense_lazy_load(last_page_content, true);
                lazyLoadInstance.update();
            } else {
                disconnect_observer();
            }

            loader_elm.style.display = "none";
            loading_in_progress = false;
        };
        request.send();
    }

    function save_scroll_position_to_history() {
        var doc_scroll_position = window.scrollY;

        // find last separator above the fold
        var separators = document.querySelectorAll(".iscroll-page-separator");
        var last_scrolled_separator = Array.prototype.filter
            .call(separators, function (elm) {
                // check if page separator position is above fold

                var rect = elm.getBoundingClientRect();

                return rect.top <= doc_scroll_position;

                // return this.offset().top <= doc_scroll_position;
            })
            .pop();

        // push history state to the browser
        if (last_scrolled_separator) {
            // TODO: Test first page

            var back_url = window.location.origin + last_scrolled_separator.getAttribute("data-href");

            // offset of content + scrolled space from last page separator

            var content_rect = content.getBoundingClientRect();
            var last_scrolled_separator_rect = last_scrolled_separator.getBoundingClientRect();
            var relative_scroll_position = Math.floor(
                content_rect.top + (doc_scroll_position - last_scrolled_separator_rect.top)
            );

            // TODO: update title
            history.replaceState(null, null, back_url);

            // save position
            window.scrollTo(0, relative_scroll_position);
        }
    }

    // init module
    init();
}
